import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { MdWorkHistory } from 'react-icons/md';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { checkIn, checkOut, getAttendanceRecords } from '../../services/attendanceServices';
const Attendance = () => {
  const [totalTime, setTotalTime] = useState({ hours: 0, minutes: 0 });
  const [checkInTime, setCheckInTime] = useState(null);
  const storedCheckInTime = localStorage.getItem('checkInTime');
  const [attendanceData, setAttendanceData] = useState([]);

  const [currentMonth, setCurrentMonth] = useState(new Date());

  const calculateTotalTime = (checkInTime) => {
    const checkIn = new Date(checkInTime); // Parse check-in time
    const now = new Date();

    const diffInMs = now - checkIn; // Difference in milliseconds
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60)); // Total minutes

    const hours = Math.floor(diffInMinutes / 60); // Calculate hours
    const minutes = diffInMinutes % 60; // Remaining minutes

    return { hours, minutes };
  };

  const isCurrentDay = (dateString) => {
    const storedDate = new Date(dateString);
    const today = new Date();

    return (
      storedDate.getFullYear() === today.getFullYear() &&
      storedDate.getMonth() === today.getMonth() &&
      storedDate.getDate() === today.getDate()
    );
  };

  // Fetch and validate check-in time from localStorage or server
  useEffect(() => {
    const fetchCheckInTime = async () => {
      if (storedCheckInTime && isCurrentDay(storedCheckInTime)) {
        setCheckInTime(new Date(storedCheckInTime));
        return;
      }

      // Clear outdated check-in time
      localStorage.removeItem('checkInTime');

      //   try {
      //     const response = await axios.get(`/api/attendance/${employeeId}`);
      //     const { checkInTime: fetchedCheckInTime } = response.data;

      //     if (fetchedCheckInTime) {
      //       const parsedCheckInTime = new Date(fetchedCheckInTime);
      //       setCheckInTime(parsedCheckInTime);
      //       localStorage.setItem("checkInTime", parsedCheckInTime);
      //     } else {
      //       console.error("No check-in time available");
      //     }
      //   } catch (error) {
      //     console.error("Error fetching check-in time:", error);
      //   }
    };

    fetchCheckInTime();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Get attendance status for a specific date
  const getAttendanceStatus = (date) => {
    const formattedDate = date.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    const attendance = attendanceData.find((record) => record.date === formattedDate);

    return attendance ? attendance.status : 'No Record';
  };

  const renderTileContent = ({ date }) => {
    const status = getAttendanceStatus(date);

    if (status === 'Present') return 'bg-green';
    if (status === 'Absent') return 'bg-danger';
    if (status === 'Pending') return 'bg-orange';
    return 'bg-lightgray';
  };

  const handleCheckIn = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user && user.id) {
        const response = await checkIn(user.id);
        const checkInTimestamp = new Date();
        setCheckInTime(checkInTimestamp);
        localStorage.setItem('checkInTime', checkInTimestamp);
      }
    } catch (error) {
      console.error('Check-in failed:', error.response?.data || error.message);
    }
  };

  const handleCheckOut = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user && user.id) {
        const res = await checkOut();

        setCheckInTime(null);
        localStorage.removeItem('checkInTime');
      }
    } catch (error) {
      console.error('Check-out failed:', error.response?.data || error.message);
    }
  };

  useEffect(() => {
    if (storedCheckInTime) {
      setCheckInTime(new Date(storedCheckInTime));
    }
  }, []);

  useEffect(() => {
    if (!checkInTime) return;
    const updateTotalTime = () => setTotalTime(calculateTotalTime(checkInTime));
    updateTotalTime();
    const interval = setInterval(updateTotalTime, 60000);
    return () => clearInterval(interval);
  }, [checkInTime]);

  const fetchAttendanceRecords = async () => {
    try {
      const response = await getAttendanceRecords();
      setAttendanceData(response?.records); // Store records in state
    } catch (error) {
      console.error('Error fetching attendance records:', error.response?.data || error.message);
    }
  };

  useEffect(() => {
    fetchAttendanceRecords();
  }, []);

  return (
    <div className="row">
      <div className="col-xl-12">
        {/* Total Time and Attendance Summary */}
        <div className="row">
          <div className="col-xl-6 col-sm-12">
            <div className="card booking">
              <div className="card-body">
                <div className="booking-status justify-content-between d-flex align-items-center">
                  <p className="my-auto">
                    <strong>Total Time:</strong> {totalTime.hours} hours {totalTime.minutes} minutes
                  </p>
                  {checkInTime ? (
                    <Button className="gradient_one" onClick={handleCheckOut}>
                      Check Out
                    </Button>
                  ) : (
                    <Button className="gradient_one" onClick={handleCheckIn}>
                      Check In
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-sm-12">
            <div className="card booking">
              <div className="card-body">
                <div className="booking-status d-flex align-items-center">
                  <div className="px-2 font-normal flex flex-row gap-x-3 text-base">
                    <p className="text-4xl my-auto ">
                      <MdWorkHistory />
                    </p>
                    <div className="flex flex-col">
                      <p className="mb-0 text-nowrap">
                        <strong>Total Working Days:</strong> {attendanceData.length}
                      </p>
                      <p className="mb-0 text-nowrap">
                        <strong>Total Attendance:</strong>{' '}
                        {attendanceData.filter((attendance) => attendance.status === 'Present').length}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Attendance Calendar and Detailed Records */}
        <div className="row mt-4">
          <div className="col-lg-5 col-md-12">
            <div className="card booking">
              <div className="card-body">
                <p className="fs-4 fw-bold">
                  Attendance for{' '}
                  {currentMonth.toLocaleDateString('default', {
                    month: 'long',
                    year: 'numeric',
                  })}
                </p>
                <Calendar
                  onActiveStartDateChange={({ activeStartDate }) => setCurrentMonth(activeStartDate)}
                  tileClassName={({ date }) => renderTileContent({ date })}
                  showNavigation={true}
                  showNeighboringMonth={false}
                  value={new Date()} // Default to today's date
                />
                {/* Calendar Enhancements */}
                <div className="mt-3">
                  <p className="fw-bold">Legend:</p>
                  <ul className="list-inline">
                    <li className="list-inline-item">
                      <span className="badge bg-green">Present</span>
                    </li>
                    <li className="list-inline-item">
                      <span className="badge bg-danger">Absent</span>
                    </li>
                    <li className="list-inline-item">
                      <span className="badge bg-orange">Pending</span>
                    </li>
                    <li className="list-inline-item">
                      <span className="badge bg-lightgray">No Data</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-7 col-md-12">
            {/* Detailed Attendance Records */}
            <div className="card booking">
              <div className="card-body">
                <h4 className="fw-bold">Detailed Attendance Records</h4>
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Check-In Time</th>
                        <th>Check-Out Time</th>
                        <th>Total Time</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {attendanceData.map((record, index) => {
                        const checkIn = record.checkInTime ? new Date(record.checkInTime) : null;
                        const checkOut = record.checkOutTime ? new Date(record.checkOutTime) : null;

                        let totalTime = '-';

                        if (checkIn && checkOut) {
                          const diffMs = checkOut - checkIn; // Difference in milliseconds
                          const totalMinutes = Math.floor(diffMs / (1000 * 60)); // Convert to minutes
                          const hours = Math.floor(totalMinutes / 60); // Extract hours
                          const minutes = totalMinutes % 60; // Extract remaining minutes

                          totalTime = `${hours} hours ${minutes} minutes`;
                        }

                        return (
                          <tr key={index}>
                            <td>{new Date(record.date).toLocaleDateString()}</td>
                            <td>{checkIn ? checkIn.toLocaleTimeString() : '-'}</td>
                            <td>{checkOut ? checkOut.toLocaleTimeString() : '-'}</td>
                            <td>{totalTime}</td>
                            <td>{record.status}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Attendance;
